import reduce from 'ramda/src/reduce';

const sum = (reports) => {
  const reduceFunction = (acc, value) => {
    acc.paidViaSquireAmount += value.paidViaSquireAmount;
    acc.paidInShopViaPosAmount += value.paidInShopViaPosAmount;
    acc.paidInShopOtherAmount += value.paidInShopOtherAmount;
    acc.paidViaGiftCardAmount += value.paidViaGiftCardAmount;
    acc.taxAmount += value.taxAmount;
    acc.totalAmount += value.total;
    acc.paidInShopOtherCount += value.paidInShopOtherCount;
    acc.paidInShopViaPosCount += value.paidInShopViaPosCount;
    acc.totalCount += value.paidInShopOtherCount + value.paidInShopViaPosCount;
    acc.discount += value.discount + value.promo;
    acc.totalDiscount += value.discount + value.promo;
    return acc;
  };
  const acc = {
    paidViaSquireAmount: 0,
    paidInShopViaPosAmount: 0,
    paidInShopOtherAmount: 0,
    taxAmount: 0,
    totalAmount: 0,
    paidInShopOtherCount: 0,
    paidInShopViaPosCount: 0,
    totalCount: 0,
    discount: 0,
    paidViaGiftCardAmount: 0,
    totalDiscount: 0,
  };

  return reduce(reduceFunction, acc, reports);
};

export default sum;
